<template>
  <div>
    <download-quality-sheet
      :visible="sheets.quality.visible"
      :mode="sheets.quality.mode || 'firstTime'"
      :initial-selected="sheets.quality.initialSelected"
      :wifi-default-quality="sheets.quality.wifiDefaultQuality"
      @select="resolveQuality"
      @cancel="resolveQuality(null)"
    />

    <confirm-remove-download
      :visible="sheets.confirm.visible"
      :item-name="sheets.confirm.itemName"
      :icon="sheets.confirm.icon"
      :title="sheets.confirm.title"
      :description="sheets.confirm.description"
      :dismiss-label="sheets.confirm.dismissLabel"
      :confirm-label="sheets.confirm.confirmLabel"
      :confirm-icon="sheets.confirm.confirmIcon"
      @confirm="resolveConfirm(true)"
      @cancel="resolveConfirm(false)"
    />

    <download-modules-sheet
      :visible="sheets.modules.visible"
      :groups="sheets.modules.groups"
      :course-id="sheets.modules.courseId"
      :files-count="sheets.modules.filesCount"
      :status="sheets.modules.status"
      @confirm="resolveModules"
      @cancel="resolveModules(null)"
    />

    <confirm-cellular-download
      :visible="sheets.cellular.visible"
      :item-name="sheets.cellular.itemName"
      @confirm="resolveCellular"
      @cancel="resolveCellular(null)"
    />
  </div>
</template>

<script>
import DownloadQualitySheet from '@/components/DownloadQualitySheet';
import ConfirmRemoveDownload from '@/components/ConfirmRemoveDownload';
import ConfirmCellularDownload from '@/components/ConfirmCellularDownload';
import DownloadModulesSheet from '@/components/DownloadModulesSheet';
import {
  downloadSheets,
  resolveQuality,
  resolveConfirm,
  resolveCellular,
  resolveModules
} from '@/services/download/downloadSheets';

// Host das sheets do fluxo de download. Montado UMA vez no AppLayout.
//
// Antes cada consumidor do mixin downloadActions montava a sheet de qualidade no
// próprio template, e as confirmações iam por $modal.show. Resultado: com o menu
// lateral e a página da aula vivos ao mesmo tempo, havia duas instâncias da
// mesma sheet (dois backdrops, duas travas de scroll do body) e dois estilos de
// abertura diferentes pro mesmo fluxo. Aqui há uma instância só, e quem pergunta
// dá await na Promise do downloadSheets.
export default {
  name: 'DownloadSheets',
  components: { DownloadQualitySheet, ConfirmRemoveDownload, ConfirmCellularDownload, DownloadModulesSheet },
  data () {
    return { sheets: downloadSheets };
  },
  methods: { resolveQuality, resolveConfirm, resolveCellular, resolveModules }
};
</script>
